import { Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { CustomerGuard } from '@next/core-lib/relationships';
import { PendingChangesGuard } from '@next/core-lib/site';

import { FertilizationLegalStandardsComponent } from './fertilization-legal-standards/components/fertilization-legal-standards.component';
import { FertilizersOverviewComponent } from './fertilizers/fertilizers-overview/fertilizers-overview.component';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/manureSubstances',
  },
  {
    path: 'manureSubstances',
    component: FertilizersOverviewComponent,
    canActivate: [CustomerGuard],
    canDeactivate: [PendingChangesGuard],
  },
  {
    path: 'fertilization-legal-standards',
    component: FertilizationLegalStandardsComponent,
    canActivate: [CustomerGuard],
  },
  ...coreRoutes,
];
